import Button from "@/components/Atoms/Button";
import Typography from "@/foundation/Typography/V2";

import TrialSection from "./TrialSection";

import CertifiedInstructors from "../../Shared/CertifiedInstructors";
import OneOnOneYogaPricingSection from "../../OneOnOneYogaPricingSection";

import { classNameGenerator, handleScrollIntoView } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./WhatHappensNext.module.scss";

interface WhatHappensNextProps { }

const WhatHappensNext: React.FC<WhatHappensNextProps> = () => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { allPackages, trialSection, trialData } = data;

  const { title, description, points, instructors, isCtaVisible = true } =
    data?.bookConsultation?.whatHappensNext || {};
  const { showOneOnOnePricingSection } = data?.heroSection || {};

  const showTrialSection =
    trialSection && trialData && !showOneOnOnePricingSection;

  return (
    <div className={cls("whatHappensNext")}>
      <div className={cls("heading")}>
        <Typography variant="heading3" className={cls("title")}>
          {title}
        </Typography>
        {description && (
          <Typography variant="paragraph1" className={cls("description")}>
            {description}
          </Typography>
        )}
      </div>
      <div className={cls("points")}>
        {points?.map((point, index) => (
          <div key={index} className={cls("point")}>
            <Typography variant="paragraph1" className={cls("count")}>
              {index + 1}.
            </Typography>
            <Typography variant="heading5" className={cls("title")}>
              {point}
            </Typography>
          </div>
        ))}
      </div>
      {showTrialSection && <TrialSection />}
      {showOneOnOnePricingSection && (
        <div className={cls("requestCallbackWrapper")}>
          <OneOnOneYogaPricingSection light />
        </div>
      )}
      {isCtaVisible && !showTrialSection && allPackages && (
        <div className={cls("viewPackages")}>
          <Button
            className={cls("actionButton")}
            onClick={() => handleScrollIntoView({ id: "all-packages-section" })}
          >
            View plans
          </Button>
        </div>
      )}
      <CertifiedInstructors />
    </div>
  );
};

export default WhatHappensNext;
